import { render, staticRenderFns } from "./bookedPickupsRow.vue?vue&type=template&id=61e705c4"
import script from "./bookedPickupsRow.vue?vue&type=script&lang=js"
export * from "./bookedPickupsRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports